var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mx-auto px-0 mt-1",staticStyle:{"padding-bottom":"120px"},attrs:{"cols":"12","sm":"11","md":"10","lg":"7","id":"wallet-container"}},[_c('Wallet',{attrs:{"headerLarge":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }